(function () {
    // Create a service to handle Google authentication
    SUGApp.service('googleService', ['$q', 'SUGUtilities', function ($q, SUGUtilities) {
        var service = {
            googleConnected: false,
            scriptLoaded: false
        };
        var setGoogleConnected = function (connected) {
            service.googleConnected = connected ? true : false;
        };
        setGoogleConnected(false);

        const clientId = window.globalcfg.googleClientid;

        const loadGoogleScript = function (callback) {
            // Load Google script if not loaded
            if (window.google && window.google.accounts && window.google.accounts.id) {
                callback();
            } else if (!service.scriptLoaded || (!window.google && !window.google.accounts && !window.google.accounts.id)) {
                var script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                script.onload = function() {
                    service.scriptLoaded = true;
                    callback();
                };
                document.head.appendChild(script);
            } else {
                setTimeout(function () { loadGoogleScript(callback); }, 50);
            }
        };

        // handle google authentication process response
        function handleGooglePostLogin(response) {
            return new Promise(function (resolve, reject) {
                // Send the token to the server for verification and login
                SUGUtilities.APISyncCallV3(
                    'post',
                    'auth/identityproviderlogin',
                    {
                        identityProviderToken: response.credential,
                        identityProviderType: 'google'
                    },
                    15000
                ).then(function (apiResponse) {
                    var result = SUGUtilities.parseSocialLoginResult(apiResponse);
                    if (result && result.token) {
                        resolve(result.token);
                    } else if (result && result.blocked) {
                        // Disabled/blocked account — no token was issued. Signal the caller so it can
                        // show the same view/message email/password login shows for this state.
                        reject(result.blocked);
                    } else {
                        reject('NO_TOKEN_RETURNED');
                    }
                }).catch(function (err) {
                    // A blocked login returns HTTP 4xx, so $http rejects into here; err.data is the
                    // response body. Surface the blocked signal instead of a generic error.
                    var result = SUGUtilities.parseSocialLoginResult(err);
                    if (result && result.blocked) {
                        reject(result.blocked);
                    } else {
                        reject(err);
                    }
                });
            });
        }

        // Handle Google login
        service.googleLogin = function(elementId) {
            var deferred = $q.defer();
            
            loadGoogleScript(function () {
                if (!service.googleConnected) {
                    window.google.accounts.id.initialize({
                        client_id: clientId,
                        callback: function (response) {
                            if (!response?.credential) {
                                deferred.reject('User authentication failed on Google');
                            }
                            // This is where you get the token!
                            handleGooglePostLogin(response).then(function (token) {
                                deferred.resolve(token);
                            }).catch(function (err) {
                                deferred.reject(err);
                            });
                        },
                        ux_mode: 'popup',
                        use_fedcm_for_prompt: true,
                        auto_select: false,
                        itp_support: true,
                    });
                    setGoogleConnected(true);
                }

                // Render the button (optional, if you want to show it)
                window.google.accounts.id.renderButton(
                    document.getElementById(elementId),
                    { theme: 'outline', size: 'large', width: '100%' }
                );
            });
            
            return deferred.promise;
        };

        return service;
    }]);
})();